import React from 'react';
import styles from './Button.module.scss';
import { getSvg } from './factory/getSvg';
import Loader from 'component/atom/loader/Loader';

const ALLOWED_VARIANTS = [
  'primary',
  'primary-rev',
  'light',
  'light-rev',
  'danger',
  'danger-rev',
  'dark',
];

const Button = ({
  children,
  variant = 'primary',
  type,
  label = '',
  className = '',
  isLoading = false,
  disabled = false,
  buttonType = 'button',
  width,
  badge,
  ...props
}) => {
  const finalVariant = ALLOWED_VARIANTS.includes(variant) ? variant : 'primary';

  const SvgIcon = type ? getSvg(type, styles['btn-icon']) : null;
  const classes = [
    styles.btn,
    styles[`btn-${finalVariant}`],
    className,
    isLoading || disabled ? styles.disabled : '',
  ].join(' ');

  return (
    <button
      className={classes}
      disabled={isLoading || disabled}
      type={buttonType}
      style={{ width }}
      {...props}
    >
      {isLoading ? (
        <Loader isComponent style={{ width: '20px', height: '21px' }} />
      ) : (
        <>
          {SvgIcon && (
            <span className={styles['icon-wrapper']}>
              <SvgIcon />
            </span>
          )}

          {(label || children) && (
            <span className={styles['label']}>{label || children}</span>
          )}

          {badge !== undefined && badge !== null && (
            <span className={styles.badge}>
              <span className={styles['badge-text']}>{badge}</span>
            </span>
          )}
        </>
      )}
    </button>
  );
};

export default Button;
